import { all, fork, take } from 'redux-saga/effects';

import type { SagaIterator } from '@redux-saga/types';

import { FetchBigStakesSuccess, fetchPendingBigStakes } from '../actions/bigStakes';
import { subscribeToBigStakeResponse } from './staking';

function* refreshBigStakes(): SagaIterator {
  while (true) {
    const action: FetchBigStakesSuccess = yield take(fetchPendingBigStakes.fulfilled);

    const actions = action.payload.data.map((bigStake) => {
      return fork(subscribeToBigStakeResponse, bigStake.dialogId);
    });

    yield all(actions);
  }
}

export default refreshBigStakes;
